import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTerms = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M18.4,23.5H5.6c-1.2,0-2.1-0.9-2.1-2.1c0,0,0,0,0,0V2.6c0-1.2,0.9-2.1,2.1-2.1c0,0,0,0,0,0 h8.9l6,6v14.9C20.5,22.6,19.6,23.5,18.4,23.5L18.4,23.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M14.5,0.5v4.7c0,0.7,0.6,1.3,1.3,1.3l0,0h4.7"
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			x1: 7.5,
			y1: 6.5,
			x2: 11,
			y2: 6.5
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			x1: 7.5,
			y1: 10.5,
			x2: 16.5,
			y2: 10.5
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			x1: 7.5,
			y1: 14.5,
			x2: 16.5,
			y2: 14.5
		})
	] })
});
export { SvgTerms as ReactComponent };
